import React from "react";
import { Image } from "react-bootstrap";
import Button from 'src/legacy/components/Button';
import styles from "./styles.module.scss";
import NoResultImage from "src/legacy/images/search/not_found.png";

import { localizedStrings } from 'src/localization';

import { toast } from "react-toastify";
import Toast from "src/components/toast";

class EmptyMessageView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      sendingNotification: false
    };

    this._handleSendNotification = this._handleSendNotification.bind(this);

    this.localizedCommons = localizedStrings.commons;
    this.localizedSearch = localizedStrings.pages.search;
    this.localizedKeywords = localizedStrings.keywords;
  }

  _handleSendNotification(){
    this.setState({
      sendingNotification: true
    });

    this.props.notifyContentModerator(this.props.searchQuery).then(() => {

        toast(<Toast.Sucess message={this.localizedSearch.empty_message.no_results.toast.notify_success}  />);

        this.setState({
          sendingNotification: false
        });  

    })
  }

  render() {
    return (
      <div className={styles.empty}>
        <Image src={NoResultImage} />
        <h3>{ this.localizedSearch.empty_message.no_results.title }</h3>

        {this.props.contentModerators && 
          <div>
            <div className={styles.notifyMessage}>
              { this.localizedSearch.empty_message.no_results.sub_text }
            </div>
              
            <div>
              <Button.Tray className={styles.buttonTray }>
                <Button
                  primary
                  disabled={this.state.sendingNotification }
                  title={this.state.sendingNotification ? this.localizedSearch.empty_message.no_results.actions.notifying : this.localizedSearch.empty_message.no_results.actions.notify }
                  className={styles.notifyButton}
                  onClick={this._handleSendNotification}
                >
                </Button>
              </Button.Tray>
            </div>
          </div>
        }

        {!this.props.contentModerators && 
          <p>{ this.localizedSearch.empty_message.no_results.description }</p>
        }
      </div>
    );
  }
}

export default EmptyMessageView;